import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';
import { Close } from './actions/closed';
import { Open } from './actions/opened';
import { Reset } from './actions/reset';
import { ComponentClassNames } from '../../../../helper/componen_class_names';

function FilterSection(props) {
    const containerClassNames = new ComponentClassNames(
        'catalog-filter-column__filter-section',
        'catalog-filter-section',
        'catalog-filter-section--' + props.containerModifier
    );
    const filterContentsClassNames = new ComponentClassNames('catalog-filter-section__filters');

    if (props.opened) {
        containerClassNames.addClassNames('catalog-filter-section--opened');
        filterContentsClassNames.addClassNames('catalog-filter-section__filters--opened');
        if (props.extraHeight) {
            filterContentsClassNames.addClassNames('catalog-filter-section__filters--extra-height');
        }
    }

    if (props.scrollable) {
        filterContentsClassNames.addClassNames('catalog-filter-section__filters--scrollable');
    }

    return (
        <div className={containerClassNames.getClassName()}>
            <Translation
                className="catalog-filter-section__headline"
                tagName="h3"
                translationKey={props.headline}
                onClick={() => !props.resettable && props.onActionClick(props.opened ? 'close' : 'open')}
            />

            {props.resettable ?
                <Reset onClick={() => props.onActionClick('reset')} /> : props.opened ?
                <Close onClick={() => props.onActionClick('close')} /> :
                <Open onClick={() => props.onActionClick('open')} />
            }

            <div className={filterContentsClassNames.getClassName()}>
                {props.children}
            </div>
        </div>
    );
}

FilterSection.propTypes = {
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    headline: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onActionClick: PropTypes.func.isRequired,
    containerModifier: PropTypes.string.isRequired,
    scrollable: PropTypes.bool.isRequired,
    extraHeight: PropTypes.bool,
};

FilterSection.defaultProps = {
    scrollable: false,
    extraHeight: false,
};

export { FilterSection };
